import React from 'react';

interface AuthBrandPanelProps {
  tagline: string;
  taglineHighlight: string;
  description: string;
  featureTags?: readonly string[];
}

const DEFAULT_FEATURE_TAGS = ['WhatsApp CRM', 'Kanban', 'Dashboard', 'Automações'] as const;

const AuthBrandPanel: React.FC<AuthBrandPanelProps> = ({
  tagline,
  taglineHighlight,
  description,
  featureTags = DEFAULT_FEATURE_TAGS,
}) => (
  <aside
    className="relative hidden overflow-hidden bg-gradient-dark p-s8 lg:flex lg:flex-1 lg:flex-col lg:items-center lg:justify-center lg:p-s10 lg:text-center"
    aria-label="Sobre o Adlitics"
  >
    <div
      className="pointer-events-none absolute -top-24 -right-24 size-72 rounded-full bg-surface-0/5"
      aria-hidden
    />
    <div
      className="pointer-events-none absolute -bottom-16 -left-16 size-56 rounded-full bg-surface-0/5"
      aria-hidden
    />

    <div className="relative z-raised flex w-full max-w-sm flex-col items-center">
      <img
        src="/logo%20principal%20dark%20140x40.png"
        alt="Adlitics"
        className="h-8 w-auto object-contain"
      />

      <h2 className="mt-s8 text-2xl text-balance text-surface-0 xl:text-3xl">
        {tagline}
        <br />
        <span className="font-semibold text-brand-300">{taglineHighlight}</span>
      </h2>

      <p className="mt-s3 text-sm leading-relaxed text-brand-300">
        {description}
      </p>

      <ul className="mt-s6 flex flex-wrap justify-center gap-s2">
        {featureTags.map((tag) => (
          <li key={tag}>
            <span className="inline-flex rounded-full border border-brand-300/40 px-s3 py-s1 text-xs uppercase text-brand-300">
              {tag}
            </span>
          </li>
        ))}
      </ul>
    </div>
  </aside>
);

export default AuthBrandPanel;
